<h1>About</h1>

<h2>Contact</h2>
<div class="card-container">
    <div class="card">
        <img src="./assets/images/IcRoundAccountBox.svg" alt="">
        <div class="card-content">
            <div class="card-title">Kevin Kornrumpf</div>
            <div class="card-description">
                PhD Student<br>
                Department of Medical Bioinformatics<br>
                University Medical Center Göttingen (UMG)<br>
            </div>
        </div>

    </div>
    <div class="card">
        <img src="./assets/images/IcRoundAccountBox.svg" alt="">
        <div class="card-content">
            <div class="card-title">Dr. Jürgen Dönitz</div>
            <div class="card-description">
                Department of Medical Bioinformatics<br>
                University Medical Center Göttingen (UMG)<br>
            </div>
        </div>
    </div>
</div>